export default __webpack_public_path__ + "static/media/zoom-in.96b1ea48.svg";